import React from 'react'

import { Div } from '@driftt/tide-core'

import ActivityTimeline from 'components/ActivityTimeline'
import { InsightOpportunity } from 'modules/accountActivity/domain'

import { CardHeader,CardHeaderExpandProps } from '../CardHeader'
import EmptyCardText from '../EmptyCardText'

import styles from './styles.module.css'

export const DealActivityCardHeader: React.FC<CardHeaderExpandProps> = ({ ...rest }) => {
  return (
    <CardHeader
      data-ocweb-id="DealActivityCardHeader"
      content={
        <div className={styles.headerContent}>
          <div>Deal activity</div>
        </div>
      }
      {...rest}
    />
  )
}

interface DealActivityCardProps {
  deal?: InsightOpportunity
}

export const DealActivityCard: React.FC<DealActivityCardProps> = ({ deal }) => {
  return (
    <>
      {!deal ? (
        <EmptyCardText
          data-ocweb-id="EmptyDealActivityText"
          content="We don't have any activity for this deal"
        />
      ) : (
        <Div className={styles.cardContainer}>
          <ActivityTimeline accountId={deal.accountId} />
        </Div>
      )}
    </>
  )
}

export default DealActivityCard
